//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TabelaGenerica from '../../../../shared-components/generico/TabelaGenerica';
import { generateComputed } from '../../../../common/functions/roles-computed-generator';

export default {
  extends: TabelaGenerica,
  props: {
    isExportAvailable: {
      type: Boolean,
      default: true,
    },
    isSearchAvailable: {
      type: Boolean,
      default: true,
    },
    isPaginationAvailable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...generateComputed('Sellout', [
      'canExport',
      'canImport',
    ]),
    isContentAvailable() {
      return !!this.tableData && !!this.tableData.length;
    },
    filteredList() {
      return [];
    },
  },
  watch: {
    searchQuery() {
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(() => {
        this.filterDatasource();
      }, 500);
    },
  },
  methods: {
    filterDatasource() {
      this.$emit('SELLOUTTABELADETALHADO_BUSCA', this.searchQuery);
    },
    formatCurrency(val) {
      return (val || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    },
    formatDecimal(val) {
      return (val || 0).toLocaleString('pt-br', { style: 'decimal' });
    },
    formatPercent(val) {
      return ((val / 100) || 0).toLocaleString('pt-br', { style: 'percent' });
    },
    retornarSellOutConsolidado() {
      this.$emit('SELLOUTTABELACONSOLIDADO_EXIBIR');
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/sell-out/SelloutTabelaDetalhado.vue?vue&type=script&lang=js&